import humps from 'humps'

import { post } from './requests'

export const search = key => payload => post(['search'], { key }, humps.decamelizeKeys(payload))
